import * as Moment from "moment";

import { DateTime as DateTime_ } from "./DateTime";
import { Duration as Duration_ } from "./Duration";
import { Interval as Interval_ } from "./Interval";
import { Zone as Zone_ } from "./Zone";

export { Moment };

export type Time = { readonly time: Time.Zone };
export namespace Time {
  export import DateTime = DateTime_;
  export import Duration = Duration_;
  export import Interval = Interval_;
  export import Zone = Zone_;

  export type State = Time;
  export namespace State {
    export const initial = (userId: number): State => ({
      time: Zone.State.initial(userId),
    });
  }
}
